import { BaseEdge, type Edge, type EdgeProps } from "@xyflow/react";

export const RuleGraphRoutedEdge = ({
  id,
  data,
  markerEnd,
  style,
}: EdgeProps<Edge<{ path: string }>>) => (
  <BaseEdge
    id={id}
    path={data?.path ?? ""}
    markerEnd={markerEnd}
    style={style}
  />
);
